import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
export default class CarouselYearHeader
{
  private readonly wrapper: HTMLElement;
  private readonly firstSlideImg: HTMLImageElement;
  private readonly loadHandler: EventListener;
  private swiper: Swiper | null = null;
  constructor(wrapper: HTMLElement)
  {
    this.wrapper = wrapper;

    const firstSlideImg = this.wrapper.querySelector('.swiper-slide:first-child img');
    if(firstSlideImg instanceof HTMLImageElement) {
      this.firstSlideImg = firstSlideImg;
    } else {
      throw new Error("First slide not found");
    }

    this.loadHandler = this.handleLoadEvent.bind(this);
    this.enable();
  }

  enable()
  {
    if(this.firstSlideImg.complete) {
      this.initSwiper();
    } else {
      this.firstSlideImg.addEventListener('load', this.loadHandler, false);
    }
  }

  destroy()
  {
    this.firstSlideImg.removeEventListener('load', this.loadHandler);
    this.swiper.destroy();
  }

  private handleLoadEvent(event: Event)
  {
    if (this.firstSlideImg.complete) {
      this.initSwiper();
    }
  }

  private initSwiper(): void
  { 
    this.firstSlideImg.classList.remove('hide');
    this.swiper = new Swiper(this.wrapper, {
      effect: 'fade',
      loop: true,
      speed: 2000,
      modules: [Autoplay, EffectFade, Pagination, Navigation],
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
    })
    this.firstSlideImg.removeEventListener('load', this.loadHandler);
  }     
}